import React from 'react';

const Banner = (props) => {
  const { message } = props;

  if (!message) {
    return null;
  }

  return (
    <div className="w-full min-h-12 flex items-center justify-center bg-[#5D38DB] text-white px-4 py-2 text-sm text-center">
      {message}
    </div>
  );
};

export { Banner };
